import { Injectable } from '@angular/core';
import { SaveFormActionHandlerService } from './save.service';
import { FormDataService } from '../data.service';
import { FormShareService } from '../share.service';
import { FormStatusService } from '../status.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { UserContextService } from '../../../user/services/user-context.service';
import { EmailService } from '../../../email/services/email.service';
import { PublishSubscribeService } from '../../../fastlane-common/services/publish-subscribe.service';
import { formStatuses } from '../../form.constants';
import { AttachmentsService } from '../../../project/services/attachments.service';
import {NavService} from '../../../fastlane-common/services/nav.service';

@Injectable({
  providedIn: 'root'
})
export class SetReceivedActionHandlerService extends SaveFormActionHandlerService {
  constructor(
    public attachmentService: AttachmentsService,
    public formDataService: FormDataService,
    public formShareService: FormShareService,
    public formStatusService: FormStatusService,
    public swalService: SwalService,
    public userContextService: UserContextService,
    public emailService: EmailService,
    public pubSubService: PublishSubscribeService,
    public navService: NavService
  ) {
    super(
      attachmentService,
      formDataService,
      formShareService,
      formStatusService,
      swalService,
      userContextService,
      pubSubService,
      emailService,
      navService
    );
  }
  exec(): Promise<any> {
    const that = this;
    return new Promise((resolve, reject) => {
      that.swalService.load('Setting Form Status to Received...');
      that.formShareService.form.changeStatus(
        formStatuses.received.name,
        '',
        that.userContextService.currentUser.id
      );
      that.formShareService.form.addReceivedDate();
      super.exec();
      that.formShareService.refreshPage();
    });
  }
}
